@if (!isLoading()) {
  <div
    class="stats-grid"
    [class.grid-single]="displayedItemsCount() == 1"
  >
    @if (config().displayOptions; as options) {
      @for (item of items; track item.name) {
        @if (options[item.name]) {
          <li class="flex items-center rounded">
            <div
              class="icon text-xl"
              [class.max]="item.name === 'max'"
              [class.min]="item.name === 'min'"
            >
              <i
                [class.icon-ic_power]="config().dataType === eStatsSupportedTypes.POWER"
                [class.icon-ic_temp]="config().dataType === eStatsSupportedTypes.THERMOSTAT"
              ></i>
            </div>
            <div>
              <div class="text-lg font-bold">
                {{ item.value }} {{ unit()?.displayShort }}
              </div>
              <div class="text-gray-600 text-sm">
                <span>{{ item.name | titlecase }} </span>
                <span class="text-gray-400 text-sm">(by {{ config().dateRange }})</span>
              </div>
            </div>
          </li>
        }
      }
    }
  </div>
} @else {
  <ngx-skeleton-loader [theme]="{ height: '200px' }" />
}
